/* global $, QAS_Variables, EmailValidation */

export default function (form, config) {
    // Runs Email Verification for All submitted email addresses
    $.extend(QAS_Variables, config);
    var email = new EmailValidation(null, "", null, form);
    email.process();
}